import type { QueryKey, UseQueryResult, UseQueryOptions, QueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import client from "@/api/client/axios";
import type { DownloadFundingDocumentQueryResponse, DownloadFundingDocumentQueryParams, DownloadFundingDocument400, DownloadFundingDocument401, DownloadFundingDocument403, DownloadFundingDocument404, DownloadFundingDocument410, DownloadFundingDocument422, DownloadFundingDocument429, DownloadFundingDocument500 } from "../types/DownloadFundingDocument";

export const downloadFundingDocumentQueryKey = (params: DownloadFundingDocumentQueryParams) =>     [{url:`/api/credit-flow-backend/v1/document/view_binary`},...(params ? [params] : [])] as const;
      export function downloadFundingDocumentQueryOptions <TData = DownloadFundingDocumentQueryResponse, TError = DownloadFundingDocument400 | DownloadFundingDocument401 | DownloadFundingDocument403 | DownloadFundingDocument404 | DownloadFundingDocument410 | DownloadFundingDocument422 | DownloadFundingDocument429 | DownloadFundingDocument500>(params: DownloadFundingDocumentQueryParams, options: Partial<Parameters<typeof client>[0]> = {}): UseQueryOptions<TData, TError> {
        const queryKey = downloadFundingDocumentQueryKey(params);

        return {
          queryKey,
          queryFn: () => {
            
            return client<TData, TError>({
              method: "get",
              url: `/api/credit-flow-backend/v1/document/view_binary`,
              params,
              
              ...options,
            }).then(res => res.data);
          },
        };
      };
      
/**
 * @link /api/credit-flow-backend/v1/document/view_binary
 */

export function useDownloadFundingDocument <TData = DownloadFundingDocumentQueryResponse, TError = DownloadFundingDocument400 | DownloadFundingDocument401 | DownloadFundingDocument403 | DownloadFundingDocument404 | DownloadFundingDocument410 | DownloadFundingDocument422 | DownloadFundingDocument429 | DownloadFundingDocument500>(params: DownloadFundingDocumentQueryParams, options: {
          query?: UseQueryOptions<TData, TError>,
          client?: Partial<Parameters<typeof client<TData, TError>>[0]>,
        } = {}): UseQueryResult<TData, TError> & { queryKey: QueryKey } {
  const { query: queryOptions, client: clientOptions = {} } = options ?? {};
  const queryKey = queryOptions?.queryKey ?? downloadFundingDocumentQueryKey(params);

  const query = useQuery<TData, TError>({
    ...downloadFundingDocumentQueryOptions<TData, TError>(params, clientOptions),
    ...queryOptions
  }) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryKey as QueryKey;

  return query;
};
